import React from 'react';
import { Container } from 'react-bootstrap';
import {AccountForm} from "./index";

const AddAccount = () => {
    return (
        <Container fluid className="">
            <AccountForm isEdit={false} />
        </Container>
    );
};

export default AddAccount;
